import React, { useState } from 'react';

import { PowerBIEmbed } from 'powerbi-client-react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { AuthorizationService } from '../service/AuthorizationService';
import { ReportService } from '../service/ReportService';
import { ProgressBar } from 'primereact/progressbar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { LanguageService } from '../service/LanguageService';

export function ReportModal(props) {

    const [report] = useState(props.report);
    const [filtersPaneVisible, setFiltersPaneVisialbe] = useState(false);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [printCheckIntervalID, setPrintCheckIntervalID] = useState(null);
    const [newSavedFilterName, setNewSavedFilterName] = useState("");
    const [embeddedReportObject, setEmbeddedReportObject] = useState(null);
    const [printPercentComplete, setPrintPercentComplete] = useState(0);

    const savedFilters = ((new AuthorizationService()).loggedInUser.bookmarks || {})[report.id] || [];
    savedFilters.push({ name: ''});

    const languageService = new LanguageService();

    const captureBookmarkConfig = async () => {
        return await embeddedReportObject.bookmarksManager.capture();
    }

    const clearFilters = () => {
        setFiltersApplied(false);
        embeddedReportObject.reload();
    }

    const header = (
        <div className="p-grid">
            <div className="p-col">
                <i className="pi pi-chart-bar" style={{fontSize: '20px', marginRight: '10px'}} />{report.name}
            </div>
            { printing && 
                <>
                <div className="p-col-fixed" style={{ width: '20px'}}>
                    <i className="pi pi-exclamation-triangle" style={{marginRight: '5px', color: 'orange'}}></i>
                </div>
                <div className="p-col-fixed" style={{ width: '360px', marginRight: '20px', fontSize: '12px', paddingTop: '10px'}}>
                    Certifique-se que o bloqueio de popups não está ativado
                </div>
                <div className="p-col-fixed" style={{ width: '20px'}}>
                    <i className="pi pi-print" style={{marginRight: '5px'}}></i>
                </div>
                <div className="p-col-fixed" style={{ width: '340px', marginRight: '20px'}}>
                    <ProgressBar
                        value={printPercentComplete}
                        displayValueTemplate={(value) => 
                                <React.Fragment>
                                    {
                                        value === 0 ? 'Aguardando...' :
                                        value === 100 ? 'Baixando aquivo...' :
                                        `Processando: ${value}%`
                                    }
                                </React.Fragment>
                        }
                    ></ProgressBar>
                </div>
                </>
            }
        </div>
    );

    const applySavedFilter = (savedFilter) => {
        embeddedReportObject.bookmarksManager.applyState(savedFilter.state);
        setFiltersApplied(true);
    }

    const deleteSavedFilter = async (savedFilter) => {
        try {
            setProcessing(true);
            const reportService = new ReportService();
            await reportService.removeReportFilterBookmark(report, savedFilter.id);
            setProcessing(false);
        } catch (error) {
            alert(error);
            setProcessing(false);
        }
    }

    const saveSavedFilter = async () => {
        try {
            setProcessing(true);
            const config = await captureBookmarkConfig();
            const reportService = new ReportService();
            await reportService.addReportFilterBookmark(report, newSavedFilterName, config.state);
            setNewSavedFilterName("");
            setProcessing(false);
        } catch (error) {
            alert(error);
            setProcessing(false);
        }
    }

    const printCurrentState = async () => {
        const config = await captureBookmarkConfig();
        await printReport(config.state);
    }

    const printSavedFilter = async (savedFilter) => {
        await printReport(savedFilter.state);
    }

    const printReport = async (state) => {
        
        try {
            setPrinting(true);
            setPrintPercentComplete(0);
            const client = (new AuthorizationService()).loggedInUser.client;
            const reportService = new ReportService();
            const data = await reportService.requestReportPrint(client, report, state);
            data.intervalId = setInterval(checkPrintStatus, 5000);
            localStorage.setItem('printRequestData', JSON.stringify(data));
            setPrintCheckIntervalID()
        } catch (error) {
            alert(error);
            setPrinting(false);
        }
    }

    const checkPrintStatus = async () => {
        const printRequestData = JSON.parse(localStorage.getItem('printRequestData') || '{}');
        try{
            const accessToken = printRequestData.accessToken;
            const exportId = printRequestData.requestData.id;
            const groupId = report.powerbi_group_id;
            const reportId = report.powerbi_report_id;
            const printRequestStatusData = await (new ReportService()).checkReportPrintStatus(accessToken, reportId, groupId, exportId);
            console.log(printRequestStatusData);

            if(printRequestStatusData.status === "Succeeded"){
                clearInterval(printRequestData.intervalId);
                console.log("acabou com sucesso");
                setPrintPercentComplete(100);
                await getReportPDF(accessToken, printRequestStatusData.resourceLocation);
            }
            else if(printRequestStatusData.status === "Failed" || printRequestStatusData.status === "Undefined"){
                clearInterval(printRequestData.intervalId);
                console.log("deu erro");
                setPrintPercentComplete(0);
                alert("Ocorreu um erro na impressao do relatorio");
            }
            else {
                console.log("ainda ta rolando", printRequestStatusData.status, printRequestStatusData.percentComplete);
                setPrintPercentComplete(printRequestStatusData.percentComplete || 0)
            }
            
        }
        catch (error) {
            clearInterval(printRequestData.intervalId);
            console.log(error);
            alert("Ocorreu um erro na impressao do relatorio");
        }
        
    }

    const getReportPDF = async (token, url) => {

        const data = await (new ReportService()).getReportPDF(token, url);
        const file = new Blob([data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        setPrinting(false);
    }

    return <Dialog
            header={header}
            visible={true} style={{ width: '100vw', height: '100vh', margin: '0' }} 
            onHide={props.onHide}
            >
                <div className="p-grid">

                    { filtersPaneVisible &&
                        <div className="p-col-12 p-lg-3">
                            
                            <p><b>{ languageService.getText("Saved_Filters") }</b></p>
                            <DataTable value={savedFilters} autoLayout={true}>
                                <Column field="name" header={ languageService.getText("Name") } body={(savedFilter) => (savedFilter.id || "") !== "" ? savedFilter.name : <InputText disabled={processing} value={newSavedFilterName} onChange={(e) => setNewSavedFilterName(e.target.value)}/>}></Column>
                                <Column body={(savedFilter) => 
                                    (savedFilter.id || "") !== "" ? 
                                    <>
                                        <Button disabled={processing || printing} icon="pi pi-play" className="p-button-rounded p-button-success p-mr-2" onClick={() => applySavedFilter(savedFilter)} />
                                        <Button disabled={processing || printing} icon="pi pi-print" className="p-button-rounded p-button-success p-mr-2" onClick={() => printSavedFilter(savedFilter)} />
                                        <Button disabled={processing || printing} icon="pi pi-trash" className="p-button-rounded p-button-success p-mr-2" onClick={() => deleteSavedFilter(savedFilter)} />
                                    </>
                                    :    
                                    <>
                                        <Button disabled={processing || printing || (newSavedFilterName || "") === ""} icon="pi pi-save" className="p-button-rounded p-button-success p-mr-2" onClick={() => saveSavedFilter()} />
                                        { processing && <ProgressBar mode="indeterminate" />}
                                    </>
                                }>
                                </Column>
                            </DataTable>
                            
                        </div>
                    }

                    { ((report.config.type || "PBI_EMBED") === "PBI_EMBED") && 
                    <div className="p-col-fixed" style={{ width: '50px'}}>
                        { !filtersPaneVisible && <Button icon="pi pi-angle-double-right" className="p-button-rounded p-button-success" style={{marginTop: '5px'}} onClick={() => setFiltersPaneVisialbe(true)} /> }
                        { filtersPaneVisible && <Button icon="pi pi-angle-double-left" className="p-button-rounded p-button-success" style={{marginTop: '5px'}} onClick={() => setFiltersPaneVisialbe(false)} /> }
                        { filtersApplied && <Button icon="pi pi-filter-slash" className="p-button-rounded p-button-success" style={{marginTop: '5px'}} onClick={() => clearFilters()} /> }
                        { !printing && <Button disabled={processing} icon="pi pi-print" className="p-button-rounded p-button-success" style={{marginTop: '5px'}} onClick={() => printCurrentState()} /> }
                        { printing && <i className="pi pi-spin pi-spinner" style={{'fontSize': '2.5em', marginTop: '5px'}}></i> }
                    </div>}
                    
                    <div className={`p-col`}>
                        { (report.config.type || "PBI_EMBED") === "PBI_EMBED" && props.embedConfig && 
                        <PowerBIEmbed
                            style={{width: '100%', height: '100%'}}
                            embedConfig={props.embedConfig}
                            eventHandlers = { 
                                new Map([
                                    ['loaded', function () {console.log('Report loaded');}],
                                    ['rendered', function () {console.log('Report rendered');}],
                                    ['error', function (event) {console.log(event.detail);}]
                                ])
                            }
                            getEmbeddedComponent = {
                                (report) => {
                                    console.log(report);
                                    setEmbeddedReportObject(report);
                                }
                            }
                        />
                        }
                        { (report.config.type || "PBI_EMBED") === "PBI_PUBLIC" &&
                            <iframe style={{width: '100%', height: '100%'}} src={report.config.pbi_report_url}/>
                        }
                    </div>

                    

                    

                </div>
                
            </Dialog>;
}